import roles from '../constants/roles';

export default function isStaff(user) {
  return [roles.coach, roles.admin, roles.superAdmin].includes(user.role);
}
